/**
 * 브라우저용 API 묶음 (TASK-2026-004).
 *
 * CSRF 토큰은 **메모리에만** 둔다. 저장소에 두면 저장소를 읽을 수 있는 코드가 쓰기
 * 권한까지 얻는다. 페이지를 열 때 `GET /api/v1/session`으로 다시 받으면 되고, 그
 * 요청은 HttpOnly cookie가 있어야 성공한다.
 */

import { createApiClient, type ApiClient, type Fetcher } from './client';

export interface Api {
  readonly client: ApiClient;
  setCsrf(token: string | undefined): void;
  csrf(): string | undefined;
}

export function createApi(fetchImpl?: Fetcher): Api {
  let token: string | undefined;
  const fetcher: Fetcher =
    fetchImpl ?? ((path, init) => globalThis.fetch(path, init));
  return {
    client: createApiClient({ fetch: fetcher, csrf: () => token }),
    setCsrf(next) {
      token = next;
    },
    csrf() {
      return token;
    },
  };
}
